import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../shared/utilities';

const initialState = {
  loading: false,
  token: null,
  userId: null,
  email: null,
  error: null,
  logoutTimeoutId: null,
  redirectLocation: '/build'
}

const authStart = (state) => {
  return updateObject(state, { error: null, loading: true });
}

const authSuccess = (state, action) => {
  return updateObject(state, { userId: action.userId, token: action.token, email: action.email, loading: false, error: null });
}

const setUserData = (state, action) => {
  return updateObject(state, { token: action.token, userId: action.userId, email: action.email })
}

const clearAuthError = (state) => {
  return updateObject(state, { error: null, loading: false });
}

const logoutTimeoutSet = (state, action) => {
  return updateObject(state, { logoutTimeoutId: action.logoutTimeoutId });
}

const logout = (state) => {
  // clear timeout so a second logout won't occur when old token would have expired

  clearTimeout(state.logoutTimeoutId)
  return updateObject(state, { userId: null, token: null, email: null, logoutTimeoutId: null })
}

const setLoginRedirect = (state, action) => {
  return updateObject(state, { redirectLocation: action.redirectLocation })
}

const authFailed = (state, action) => {
  let error = 'Oops. Something went wrong.'
  switch (action.error) {
    case 'INVALID_PASSWORD': error = 'Incorrect password. Try again.';
      break;
    case 'EMAIL_NOT_FOUND': error = 'An account with that email does not exist.'
      break;
    case 'EMAIL_EXISTS': error = 'An account already exists with that email.'
      break;
    case 'TOO_MANY_ATTEMPTS_TRY_LATER : Access to this account has been temporarily disabled due to many failed login attempts. You can immediately restore it by resetting your password or you can try again later.': error = 'Too many attempts.  Try again later or reset your password.'
      break;
    default:
      error = action.error;
  }
  return updateObject(state, { loading: false, error: error });
}

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.AUTH_START: return authStart(state, action);
    case actionTypes.AUTH_SUCCESS: return authSuccess(state, action);
    case actionTypes.AUTH_FAILED: return authFailed(state, action);
    case actionTypes.CLEAR_AUTH_ERROR: return clearAuthError(state, action);
    case actionTypes.LOGOUT: return logout(state, action);
    case actionTypes.LOGOUT_TIMEOUT_SET: return logoutTimeoutSet(state, action);
    case actionTypes.SET_USER_DATA: return setUserData(state, action);
    case actionTypes.SET_LOGIN_REDIRECT: return setLoginRedirect(state, action);
    default: return state;
  }
}

export default authReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/authReducer.jsx